import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {Spinner} from "../Spinner";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";

// Snooze constants
const TODAY_PERIOD = 'TODAY';

export class SnoozeAllAlertsButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changingSnoozeState: false
        };

        this.handleSnoozeAllAlerts = this.handleSnoozeAllAlerts.bind(this);
        this.handleStopSnooze = this.handleStopSnooze.bind(this);
    }

    // api calls

    _apiSnoozeUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/alert-snooze-all`;
    }

    apiSnoozeAllAlerts() {
        this.setState({changingSnoozeState: true});
        const postData = {
            period: TODAY_PERIOD,
        };
        new APIClient(this._apiSnoozeUrl()).call('POST', postData).then(() => {
            this.setState({changingSnoozeState: false});
            this.props.onSnooze();
        });
    }

    apiStopAllSnoozes() {
        this.setState({changingSnoozeState: true});
        new APIClient(this._apiSnoozeUrl()).call('DELETE').then(() => {
            this.setState({changingSnoozeState: false});
            this.props.onStopSnooze();
        });
    }

    // events

    handleSnoozeAllAlerts() {
        this.apiSnoozeAllAlerts();
    }

    handleStopSnooze() {
        this.apiStopAllSnoozes();
    }

    // rendering

    renderButton() {
        if (this.props.isSnoozed !== null && !this.state.changingSnoozeState) {
            if (this.props.isSnoozed) {
                return (
                    <div>
                        <button className="bu-cell-button snooze -on" onClick={this.handleStopSnooze}>
                            <FaIcon iconName="bell-slash"/>
                        </button>
                    </div>
                )
            } else {
                return (
                    <button className="bu-cell-button snooze" onClick={this.handleSnoozeAllAlerts}>
                        <FaIcon iconName="bell-slash"/>
                    </button>
                )
            }
        } else {
            return <div className="bu-cell-button">
                <Spinner color="positive very-small"/>
            </div>
        }
    }

    render() {
        return (
            <div>
                {this.renderButton()}
            </div>
        );
    }
}

